import { useEffect, useMemo } from 'react'
import { initialQueryState, useDebounce } from '../../../../../../../_metronic/helpers'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { useListFilters } from '../../core/ListFiltersProvider'
import {
  ActiveFilter,
  ActiveFiltersBar,
  Input,
  TableFilter,
  TableFilters,
} from '../../../../../../components'
import { useT } from '_metronic/i18n/Metronici18n'

const EmpresasListSearchComponent = () => {
  const { updateState } = useQueryRequest()
  const { response, isLoading } = useQueryResponse()
  const { filters, setFilter, clearFilters } = useListFilters()
  const { t } = useT()
  const total = response?.totalElements ?? 0

  const debouncedFilters = useDebounce(filters, 500)

  // Razão social OU nome fantasia (o `'` antes do campo é o "ou" da sintaxe de search da API).
  const search = useMemo(() => {
    const termo = debouncedFilters.empresa.trim()
    return termo ? `nome~*${termo}*,'nomeFantasia~*${termo}*` : ''
  }, [debouncedFilters])

  useEffect(() => {
    updateState({ ...initialQueryState, search })
  }, [search, updateState])

  // Chip da faixa "Filtros ativos": o × limpa o campo.
  const activeFilters: ActiveFilter[] = filters.empresa.trim()
    ? [
        {
          key: 'empresa',
          label: t('empresa.label'),
          value: `“${filters.empresa.trim()}”`,
          onRemove: () => setFilter('empresa', ''),
        },
      ]
    : []

  return (
    <TableFilters
      footer={
        <ActiveFiltersBar
          filters={activeFilters}
          onClearAll={clearFilters}
          summary={
            isLoading
              ? 'Buscando…'
              : `${total} ${total === 1 ? 'instituição encontrada' : 'instituições encontradas'}`
          }
        />
      }
    >
      <TableFilter label={t('empresa.label')} wide>
        <Input
          placeholder='Nome fantasia ou razão social'
          value={filters.empresa}
          onChange={(e) => setFilter('empresa', e.target.value)}
        />
      </TableFilter>
    </TableFilters>
  )
}

export { EmpresasListSearchComponent }
